import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as date from "../../booking/helpers/date"
import { DateTime } from "luxon"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import { hosts } from "./itinerary-module"
import * as cookieNames from "../../booking/constants/Cookies"
import { Cookies } from "react-cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryParking extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      hidePastSteps: props.hidePastSteps,
      parkingBookings: undefined,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  componentDidMount() {
    if (this.state.profile && this.state.profile !== {}) {
      this.setState({ isLoggedIn: true }, () => {
        this.setLoginState()
      })
    }
  }

  componentDidUpdate() {
    if (this.state.profile !== this.props.profile) {
      this.setState({ profile: this.props.profile }, () => {
        this.setLoginState()
      })
    }
  }

  setLoginState = () => {
    const cookies = new Cookies()
    const cookieToken = cookies.get(cookieNames.ACCESS_TOKEN)
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        // session timed out or logout was forced
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        this.setState({ parkingBookings: undefined })
      }
    } else if (cookieToken !== currentToken || !this.state.parkingBookings) {
      // new token arrived or state is not loaded
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      if (this.state.profile && this.state.profile !== {}) this.getParkingBooking()
    }
  }

  getParkingBooking = () => {
    const url =
      endpoint.BOOKING_LIST(hosts, this.state.flightInfo.language) +
      "?flightDate=" +
      this.state.flightInfo.EstimatedPublicTime +
      "&leadTimeHours=" +
      this.props.block.parkingHoursBeforeFlight
    axios
      .get(url)
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            parkingBookings: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasAccodionContentBlocks = this.props.block.contentArea?.length > 0

    let buttonLink = this.props.block.buttonLink
    if (this.props.block.linkToAirlineBool) buttonLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    if (this.props.block.buttonAddParkingQueryString) {
      const ROUNDING = 30 * 60 * 1000 /*ms*/
      const dtLocale = date.luxonLocale(this.state.flightInfo.language)
      const zone = "Europe/Copenhagen"
      const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      const flightInfoDate = estimatedPublicTime.minus({ minutes: this.props.checkInOpens }).minus({ minutes: 60 })
      const roundedDate = DateTime.fromMillis(Math.round(+flightInfoDate.toMillis() / ROUNDING) * ROUNDING)
        .setLocale(dtLocale)
        .setZone(zone)
      buttonLink += `?ad=${roundedDate.toFormat("yyyy-MM-dd")}&at=${roundedDate.toFormat("HH")}:00` // floor to the hour
    }

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return this.state.parkingBookings && this.state.parkingBookings.length > 0 ? (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          onClick={(e) => this.showHideContent(e, ".contentWrapper")}
        >
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={buttonLink}
                    onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          <div className={"parking-bookings-container"}>
            {this.state.parkingBookings.map((booking, i) => {
              let parkingRecieptLink = this.props.block.parkingLink + "/receipt?bguid=" + booking.booking.guid
              const dtLocale = date.luxonLocale(this.state.flightInfo.language)
              const zone = "Europe/Copenhagen"
              const arrivalDate = DateTime.fromISO(booking.booking.arrivalDate).setLocale(dtLocale).setZone(zone)
              const departureDate = DateTime.fromISO(booking.booking.departureDate).setLocale(dtLocale).setZone(zone)

              return (
                <React.Fragment key={i}>
                  <div className="tablediv">
                    <div className="tablediv__row">
                      <div className="tablediv__row__cell bold">{this.props.block.referenceLabel || "Reservationsnummer"}</div>
                      <div className="tablediv__row__cell">{booking.booking.reference}</div>
                    </div>
                    <div className="tablediv__row">
                      <div className="tablediv__row__cell bold">{this.props.block.productLabel || "Produkt"}</div>
                      <div className="tablediv__row__cell">{`${booking.product.name} ${booking.carPark.name}`}</div>
                    </div>
                    <div className="tablediv__row">
                      <div className="tablediv__row__cell bold">{this.props.block.parkingTimeLabel || "Parkeringstidspunkt"}</div>
                      <div className="tablediv__row__cell">{`${arrivalDate.toFormat("DD")}, ${booking.booking.arrivalTime} - ${departureDate.toFormat(
                        "DD",
                      )}, ${booking.booking.departureTime}`}</div>
                    </div>
                  </div>
                  <div className="textbuttoncontainer">
                    <span className="rich-text"></span>
                    {this.props.block.showMoreButtonText && this.props.block.parkingLink ? (
                      <div className="cta-button">
                        <a
                          className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                            buttonColor ? buttonColor : "casc-blue"
                          }`}
                          href={parkingRecieptLink}
                          onClick={() => this.handleClickTracking(this.props.block.showMoreButtonTracking)}
                        >
                          <span className="text">{this.props.block.showMoreButtonText}</span>
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </React.Fragment>
              )
            })}
          </div>
          {hasAccodionContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    ) : (
      ""
    )
  }
}
